import './settings/components/import-export'

import admin from '../../web-sh/src/pages/admin'

import Vault from './vault'
import VaultHistory from './vault/history'

import SettingsAccount from './settings/settings-account'
import SettingsSecurity from './settings/settings-security'
import SettingsMembers from './settings/settings-members'
import SettingsPlansBilling from './settings/settings-plans-billing';

import PrivateEmail from './private-email';
import SecurityTools from './security-tools';
import Rewards from './rewards';
import ManagePlans from './manage-plans';
import WelcomeTour from './welcome-tour';
import Policies from './policies';

import CheckScam from './check-scam';
import ScamMyReport from './check-scam/report';
import ScamSetting from './check-scam/setting';

export default {
  ...admin,

  Vault,
  VaultHistory,

  SettingsAccount,
  SettingsSecurity,
  SettingsMembers,
  SettingsPlansBilling,

  PrivateEmail,
  SecurityTools,
  Rewards,
  ManagePlans,
  WelcomeTour,
  Policies,

  CheckScam,
  ScamMyReport,
  ScamSetting
}